<div class="chat-app">
  <mat-sidenav-container

  [ngClass]="{ 'side-panel-opened': sidePanelOpened, 'side-panel-closed': !sidePanelOpened }" >
    <mat-sidenav
    fixedInViewport="true"
    fixedTopGap="20"
    fixedBottomGap="0"
      [mode]="isOver() ? 'over' : 'side'"
      [opened]="true"
      (open)="sidePanelOpened = true"
      (close)="sidePanelOpened = false"
    >
      <ng-scrollbar>
        <div class="p-x-24">
          <div class="d-flex align-items-center justify-content-between">
            <app-branding [width]="120"></app-branding>
            <i-tabler matTooltip="{{'Chat.NewChat' | localize}}" name="edit" class="cursor-pointer" (click)="newChat()"></i-tabler>
          </div>
          <!-- search -->
          <mat-form-field appearance="outline" class="w-100 p-t-24">
            <input
              matInput
              placeholder="{{'Chat.SearchChats' | localize}}"
              [(ngModel)]="searchTerm"
              (input)="searchSessions()"
            />
            <mat-icon matSuffix>
              <i-tabler
                name="search"
                class="icon-20 d-flex align-items-end m-t-2"
              ></i-tabler>
            </mat-icon>
          </mat-form-field>
        </div>
        @if (filteredSessions && filteredSessions.length > 0) {
          <div class="m-x-12">
            <mat-nav-list class="chat-listing">
              @for(session of filteredSessions; track session.id) {
              <mat-list-item
                 style="height: 36px;"              >
                <div class="f-w-600 f-s-14 p-t-16 d-flex justify-content-between" matTooltipPosition="after" matTooltip="{{ session.session_title }}">
                      <p (click)="selectSession(session)" class="w-100">{{ session.session_title.length>30? session.session_title.substring(0,30)+'...':session.session_title }}</p>
                    <i-tabler  (click)="deleteSession(session)" name="trash-x" class="float-end  icon-18" ></i-tabler>

                </div>
              </mat-list-item>
              }
            </mat-nav-list>
          </div>
          } @else {
          <div
            class="p-15 bg-light-primary text-primary rounded m-x-20 m-t-20 text-center"
          >
            <span class="f-s-14">No sessions found.</span>
          </div>
          }

      </ng-scrollbar>
    </mat-sidenav>
    <mat-sidenav-content     fixedInViewport="true"
    fixedTopGap="20"
    fixedBottomGap="0"
    class="justify-content-between">
      <!-- ------------------------------------------- -->
      <!-- chat details -->
      <!-- ------------------------------------------- -->
      <mat-toolbar class="chat-right-panel b-b-1 gap-8">
        <button mat-icon-button [matMenuTriggerFor]="moredd" matTooltip="{{'Chat.Settings' | localize}}">
          <i-tabler name="settings" class="m-l-auto" ></i-tabler>
        </button>
        <mat-menu #moredd="matMenu" x-position="before">
          <button mat-menu-item>{{'Chat.SpeakingTone' | localize}}</button>
          <button mat-menu-item>{{'Chat.Creativity' | localize}}</button>
        </mat-menu>
        <div class="d-flex align-items-center gap-16 flex-grow-1">

          <div class="model-selector-container" matTooltip="{{'Chat.SelectModel' | localize}}">
            <mat-form-field appearance="outline" class="model-selector no-border">
              <mat-select
                panelClass="model-dropdown-panel"
                [(ngModel)]="selectedModel"
                (selectionChange)="changeModel($event.value)"
                (click)="handleModelClick($event)">
                <mat-option *ngFor="let model of availableModels" [value]="model.id">
                  {{ model.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>
        <button [matMenuTriggerFor]="flags" mat-icon-button matTooltip="{{'Chat.Language' | localize}}">
          <i-tabler name="language"></i-tabler>
        </button>
        <mat-menu #flags="matMenu">
          @for(lang of languages; track lang.icon) {
          <button mat-menu-item (click)="changeLanguage(lang)">
            {{ lang.language }}
          </button>
          }
        </mat-menu>
        <button mat-icon-button [routerLink]="['/dashboard']" target="_blank" matTooltip="{{'Chat.Management' | localize}}">
          <i-tabler name="building" class="m-l-auto" ></i-tabler>
        </button>
        <button mat-icon-button (click)="setLightDark(options.theme === 'light' ? 'dark' : 'light')" matTooltip="{{'Chat.Theme' | localize}}">
          <i-tabler [name]="options.theme === 'light' ? 'moon' : 'sun'"></i-tabler>
        </button>
        
      </mat-toolbar>

      <!-- ------------------------------------------- -->
      <!-- chat content -->
      <!-- ------------------------------------------- -->
      <ng-scrollbar
      #chatScrollbar id="chatScrollbar"
      [style.height]="selectedSession && selectedSession.messages.length > 1 ? 'calc(100vh - 200px)' : 'calc(100vh - 140px)'"
      [ngClass]="{'no-session-container': !selectedSession}">
        
        <!-- Welcome UI (ChatGPT-like centered layout) -->
        <ng-container *ngIf="!selectedSession">
          <div class="welcome-container">
            <div class="welcome-content">
              <div class="welcome-message">
                
                <img
                  src="{{ botImage }}"
                  class="logolight"
                  width="60"
                  height="60"
                />
                <img
                  src="{{ botImageLight }}"
                  class="logodark"
                  width="60"
                  height="60"
                />
                <div class="welcome-text f-s-16 f-w-600 m-t-16">{{ llmSettings.welcomeMessageChatBotUi }}</div>
              </div>
              
              <!-- Centered input for welcome state -->
              <div class="welcome-input-container">
                <mat-form-field appearance="outline" class="w-100">
                  <input #messageInput
                    matInput
                    placeholder="{{'Chat.SendMessage' | localize}}"
                    [(ngModel)]="messageText"
                    (keydown.enter)="sendMessage()"
                    [disabled]="isStreaming"
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="sendMessage()"
                    [disabled]="!messageText || isStreaming"
                  >
                    <mat-icon>send</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Chat messages (existing layout) -->
        <ng-container *ngIf="selectedSession">
          <mat-card-content class="p-24">
            <div *ngFor="let c of selectedSession.messages; let i = index">
              <!-- Bot message -->
              <div *ngIf="c.role === 'assistant'" class="chat-list odd p-x-48 ">
                <div class="m-b-15">
                  <div class="p-10 rounded d-flex">
                    <img
                      src="{{ botImage }}"
                      class="rounded-circle align-self-start"
                      width="40"
                      height="40"
                      style="margin-right: 16px;"
                    />
                    <div class="flex-column justify-content-start">
                      @if (isSearching && c?.searchResults?.length > 0) {
                        <div>
                          <div class="d-flex align-items-center mb-2">
                            <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
                            <div class="">Dosyalarda Arıyorum...</div><!--                        TODO : Localize-->
                          </div>
                          <div class="d-flex align-items-center border-1 gap-5 file-buttons-container">
                            @for (doc of c.searchResults; track doc.id; let buttonIndex = $index) {
                              <button
                                class="file-button rounded-pill d-flex align-items-center justify-content-center p-y-5 p-x-10 border-2"
                                [style.z-index]="1000 - buttonIndex"
                                (click)="openFilesWithMediaComponent(c.searchResults[buttonIndex])"
                              >
<!--                                TODO : Doküman tipine göre iconlar eklenmeli.-->
                                <i-tabler name="{{doc.file_key === null ? 'world' : doc.metadata.doc_type === 'pdf' ? 'file-type-pdf' : doc.metadata.doc_type === 'txt' ? 'file-type-txt' : doc.metadata.doc_type === 'image' ? 'photo-scan' : doc.metadata.doc_type === 'video' ? 'video' : doc.metadata.doc_type === 'excel' ? 'file-spreadsheet' : ''}}"></i-tabler>
                                <span class="file-name">{{doc.metadata.file_name}}</span>
                              </button>
                            }
                          </div>
                        </div>
                      }
                      <div class="f-s-16 f-w-400 markdown-content" [innerHTML]="getRenderedContent(c.content)"></div>
                      <div>
<!--                        TODO: Referans gösterilen doküman ya buraya gelmeli yada rendered content içerisine aktarılmalı.-->
                      </div>
                    </div>
                  </div>
                  <span class="f-s-12 d-flex gap-2 align-items-center">
                    <span *ngIf="isStreaming && i === selectedSession.messages.length-1" class="streaming-indicator">
                      <span class="dot-1">.</span>
                      <span class="dot-2">.</span>
                      <span class="dot-3">.</span>
                    </span>
                  </span>
                </div>
              </div>
              <!-- User message -->
              <div *ngIf="c.role === 'user'" class="chat-list even p-x-48">
                <div class="m-b-15">
                  <div
                    class="bg-light-secondary p-10 rounded d-flex"
                  >
                    <div class="markdown-content" [innerHTML]="getRenderedContent(c.content)"></div>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </ng-container>
      </ng-scrollbar>

      <!-- ------------------------------------------- -->
      <!-- Message Send Part (only shown when session is selected) -->
      <!-- ------------------------------------------- -->

      <div *ngIf="selectedSession" class="p-l-24 p-r-24" style="max-width: 68rem; margin: 0 auto;">
        <mat-form-field appearance="outline" class=" w-100">
          <textarea #messageInput
            matInput
            style="min-height: 4.5em; overflow-y: scroll !important;"
            class="resize-y max-h-40 border rounded w-full py-2 pl-3 pr-9 text-slate-700 outline-none overflow-hidden border-black-200 hover:border-black-300 focus:border-black-300 scroll-smooth lg:overflow-auto scrollbar:!w-1.5 scrollbar:!h-1.5 scrollbar:bg-transparent scrollbar-track:!bg-slate-100 scrollbar-thumb:!rounded scrollbar-thumb:!bg-slate-300 scrollbar-track:!rounded dark:scrollbar-track:!bg-slate-500/[0.16] dark:scrollbar-thumb:!bg-slate-500/50"
            placeholder="{{'Chat.SendMessage' | localize}}"
            [(ngModel)]="messageText"
            (keydown.enter)="sendMessage()"
            [disabled]="isStreaming"
          ></textarea>
          <button
            mat-icon-button
            matSuffix
            (click)="sendMessage()"
            [disabled]="!messageText || isStreaming"
          >
            <mat-icon>send</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<style>
  ::ng-deep .mat-mdc-form-field-bottom-align{
    margin-bottom: -1.25em;
  }
  
  /* Chat content max-width and responsive behavior */
  .chat-app mat-card-content {
    max-width: 68rem;
    margin: 0 auto;
    width: 100%;
    display: block;
  }
  
  /* Responsive behavior for smaller screens */
  @media (max-width: 768px) {
    .chat-app mat-card-content {
      max-width: calc(100vw - 2rem);
      margin: 0 1rem;
    }
  }
  
  @media (max-width: 480px) {
    .chat-app mat-card-content {
      max-width: calc(100vw - 1rem);
      margin: 0 0.5rem;
    }
  }
  
  .streaming-indicator {
    display: inline-flex;
    margin-left: 4px;
  }

  .streaming-indicator .dot-1,
  .streaming-indicator .dot-2,
  .streaming-indicator .dot-3 {
    animation: dots 1.5s infinite;
    font-size: 16px;
    line-height: 1;
  }

  .streaming-indicator .dot-2 {
    animation-delay: 0.5s;
  }

  .streaming-indicator .dot-3 {
    animation-delay: 1s;
  }

  @keyframes dots {
    0%, 20% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  .markdown-content {
    flex: 1;
    width: 100%;
  }

  .markdown-content ::ng-deep p {
    margin: 0;
  }

  .markdown-content ::ng-deep pre {
    background-color: rgba(0, 0, 0, 0.05);
    padding: 8px;
    border-radius: 4px;
    overflow-x: auto;
  }

  .markdown-content ::ng-deep code {
    background-color: rgba(0, 0, 0, 0.05);
    padding: 2px 4px;
    border-radius: 4px;
  }

  .markdown-content ::ng-deep ul,
  .markdown-content ::ng-deep ol {
    margin: 8px 0;
    padding-left: 20px;
  }

  .markdown-content ::ng-deep blockquote {
    border-left: 4px solid #ccc;
    margin: 8px 0;
    padding-left: 16px;
    color: #666;
  }

  /* Model selector styles */
  ::ng-deep .model-selector-container {
    flex: 1;
    max-width: 300px;
    --mat-sys-outline: transparent !important;
    --mdc-outlined-text-field-hover-outline-color: transparent !important;
  }


  .model-selector {
    width: 100%;
    margin: 0;
    --mat-sys-outline: transparent !important;
    --mdc-outlined-text-field-hover-outline-color: transparent !important;
    --mat-sys-primary: transparent !important;
  }

  .model-selector ::ng-deep .mat-mdc-form-field-infix {
    padding-top: 8px;
  }

  .model-selector ::ng-deep .mat-mdc-form-field-subscript-wrapper {
    display: none;
  }

  .model-selector ::ng-deep .mat-mdc-form-field-flex {
    align-items: center;
  }

  /* Adjust dropdown panel width */
  ::ng-deep .model-dropdown-panel.mat-mdc-select-panel {
    min-width: 240px !important;
  }

  html, body {
    overflow-x: hidden;
  }

  /* File button hover styles */
  .file-button {
    position: relative;
    transition: all 0.3s ease;
    overflow: hidden;
    margin-right: -20px;
  }

  .file-button .file-name {
    opacity: 0;
    max-width: 0;
    overflow: hidden;
    white-space: nowrap;
    transition: all 0.3s ease;
    margin-left: 0;
  }

  .file-button:hover .file-name {
    opacity: 1;
    max-width: 200px;
    margin-left: 8px;
  }

  .file-button:hover {
    padding-right: 16px !important;
    transform: translateX(20px);
    z-index: 10;
  }

  /* Butonların üst üste binmesi için container */
  .file-buttons-container {
    position: relative;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }

  .file-buttons-container .file-button {
    margin-right: -20px; /* Butonları daha fazla üst üste bindirmek için */
    position: relative;
    border: 2px solid var(--mat-sys-primary-fixed-dim) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: var(--mat-sys-primary);
  }

  .file-buttons-container .file-button:hover {
    margin-right: 0; /* Hover durumunda margin'i sıfırla */
    transform: translateX(20px); /* Sağa kayma */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000 !important;
  }

  /* Welcome screen styles (ChatGPT-like centered layout) */
  .no-session-container {
    margin: 0 !important;
    position: relative;
  }

  .welcome-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
  }

  .welcome-content {
    max-width: 600px;
    width: 100%;
    text-align: center;
  }

  .welcome-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 32px;
  }

  .welcome-text {
    color: var(--mat-sys-on-surface);
    line-height: 1.6;
    max-width: 600px;
  }

  .welcome-input-container {
    width: 100%;
  }

  .welcome-input-container .mat-mdc-form-field {
    width: 100%;
  }

  .welcome-input-container ::ng-deep .mat-mdc-form-field-wrapper {
    padding-bottom: 0;
  }

  .welcome-input-container ::ng-deep .mat-mdc-form-field-subscript-wrapper {
    display: none;
  }
  .welcome-input-container {
    transition: all 0.5s ease-in-out;
  }

  .welcome-input-container.active {
    transform: translate(-50%, -50%);
  }

  
:deep(table) {
  @apply mb-4;

  border-style: solid;
  border-color: #ffffff14;
  border-width: 1px;
}

:deep(table tbody tr:is(.dark *)) {
  border-color: hsl(255 0.6% 50.8% / 1.3);
}

:deep(pre) {
  @apply overflow-y-scroll max-h-56 mb-3;

  background-color: #f4f4f41A;
  padding: 10px;
  border-radius: 5px;
  overflow-y: scroll !important;
  max-height: 14rem !important;
}

textarea {
  line-height: 1.5;
  height: auto;
  border-radius: 10px;
}

/* width */
:deep(::-webkit-scrollbar) {
  width: .375rem;
  height: .2rem;
  background: transparent;
}

/* Track */
:deep(::-webkit-scrollbar-track) {
  background: transparent;
}

/* Handle */
:deep(::-webkit-scrollbar-thumb) {
  background: #888;
  border-radius: 5px;
}

/* Handle on hover */
:deep(::-webkit-scrollbar-thumb:hover) {
  background: #555;
}

</style>
